import { TeamSportSubscriptionDetail } from '../../types/admin/subscriptionTracker';
import { formatDaysRemaining, formatSubscriptionDate } from './formatSubscriptionDate';

function escapeCsvValue(value: string | number | boolean | null | undefined): string {
  const str = value == null ? '' : String(value);
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportTeamPlanCsv(
  teamName: string,
  teamCode: string,
  sports: TeamSportSubscriptionDetail[]
): void {
  const headers = [
    'Team',
    'Sport',
    'Display Status',
    'Raw Status',
    'Start',
    'End',
    'Days Remaining',
    'Is Grace',
    'Activated By',
  ];
  const dateStamp = new Date().toISOString().slice(0, 10);

  const rows = sports.map((sport) => [
    escapeCsvValue(teamName),
    escapeCsvValue(sport.sport_code),
    escapeCsvValue(sport.display_status),
    escapeCsvValue(sport.status),
    escapeCsvValue(formatSubscriptionDate(sport.start_date)),
    escapeCsvValue(formatSubscriptionDate(sport.end_date)),
    escapeCsvValue(formatDaysRemaining(sport.days_remaining)),
    escapeCsvValue(sport.is_grace ? 'Yes' : 'No'),
    escapeCsvValue(sport.activated_by || '—'),
  ]);

  const csv = [headers.join(','), ...rows.map((row) => row.join(','))].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${teamCode}_team_plan_${dateStamp}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
